//import store from '@/store/index.js'
//import { format } from '@/common/common'
import { post } from '@/request/http'

class eventApi {
  CommonEventApi(
    api,
    param,
    loaddom,
    confirmdom,
    loadmessage,
    fHandleRejection = false
  ) {
    return new Promise((resolve, reject) => {
      if (loaddom) {
        loaddom.show(loadmessage, {
          type: 'alert'
        })
      }
      api(param)
        .then(res => {
          if (loaddom) {
            loaddom.hidden()
          }
          this.refreshToken()
          var data = res.data
          if (data.isSuccess != null && data.isSuccess != undefined) {
            if (data.isSuccess) {
              resolve(data.result)
            } else {
              this.showError(loaddom, confirmdom, data.errorMessage)
              if (fHandleRejection) {
                reject(data.result)
              }
            }
          } else {
            resolve(data)
          }
        })
        .catch(res => {
          var message = ''
          if (res.data && res.data.error && res.data.error.message) {
            message = res.data.error.message
          }
          this.showError(loaddom, confirmdom, message)

          if (fHandleRejection) {
            reject(res.data)
          }
        })
    })
  }
  showError(loaddom, comfirmdom, message) {
    if (loaddom) {
      loaddom.hidden()
    }
    if (comfirmdom) {
      comfirmdom.show(message || 'An error has occurred.', {
        type: 'alert'
      })
    }
  }
  refreshToken() {
    var validationUrl = process.env.VUE_APP_TOKEN_API + '/token/refresh'
    post(validationUrl).then(res => {
      var data = res.data
      if (data.Token) {
        localStorage.setItem('Token', data.Token)
      }
    })
  }
}
export default eventApi
